export default "__VITE_PUBLIC_ASSET__57e01ab1__"